module.exports = __webpack_public_path__ + "img/Android6.6538373f.png";